<template>
  <v-container fluid>
      <v-card elevation="10">
      <v-card-title class="text-h6 blue lighten-2 white--text">
        <v-btn
            icon
            to="/programok"
            >
            <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <v-spacer/>
        Mobilos próba 1-2!
      </v-card-title>
      <v-card-text class="mt-3 black--text">
        Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.
        <v-row class="mt-3">
          <v-carousel
            hide-delimiter-background
            delimiter-icon="mdi-circle"
            :show-arrows="false"
            height="35rem"
            cycle
          >
            <v-carousel-item
            src= "@/assets/slider/1.jpg"
            src_min="@/assets/slider/1.jpg">
            </v-carousel-item>
            <v-carousel-item
            src= "@/assets/slider/2.jpg"
            src_min="@/assets/slider/2.jpg">
            </v-carousel-item>
            <v-carousel-item
            src= "@/assets/slider/3.jpg"
            src_min="@/assets/slider/3.jpg">
            </v-carousel-item>
          </v-carousel>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
    name:"MobilePost"
}
</script>

<style>

</style>